import React, { useMemo } from 'react';
import type { DeleteAnnotationModalContentComponentProps } from '@uber/label-modalities/src/modernization-common/side-panel/types';
import { useAtomValue } from 'jotai';
import { SIDE_PANEL_ACTIONS } from '../../../../../modernization-common/side-panel/const';
import { useDispatch } from '../../../../../modernization-common/side-panel/hooks/use-dispatch';
import { isVideoTaskAtom, numFramesAtom } from '../../../atoms/annotation-atoms';
import { frameRateAtom } from '../../../atoms/file-atoms';
import { relationshipStoreAtom } from '../../../atoms/relationship-atoms';
import { allAnnotationMapAtom } from '../../../atoms/side-panel-atoms';
import { timeDisplayModeAtom } from '../../../atoms/tool-atoms';
import { DeleteModalContent } from './content';
export const DeleteAnnotationModalContainer = ({
  onCancel,
  onSubmit,
  annotationId
}: DeleteAnnotationModalContentComponentProps) => {
  const allAnnotationMap = useAtomValue(allAnnotationMapAtom);
  const isVideoTask = useAtomValue(isVideoTaskAtom);
  const timeDisplayMode = useAtomValue(timeDisplayModeAtom);
  const frameRate = useAtomValue(frameRateAtom);
  const maxFrames = useAtomValue(numFramesAtom);
  const relationshipStore = useAtomValue(relationshipStoreAtom);
  const associatedRelationships = useMemo(() => Object.values(relationshipStore).filter(r => r.sourceAnnotationId === annotationId || r.targetAnnotationId === annotationId), [relationshipStore, annotationId]);
  const dispatch = useDispatch();
  const handleSubmit = async (startFrameCount: number, endFrameCount: number) => {
    if (isVideoTask) {
      dispatch({
        type: SIDE_PANEL_ACTIONS.DELETE_ANNOTATION_FRAME_SPAN,
        annotationIdx: annotationId,
        frameSpan: {
          start: startFrameCount - 1,
          end: endFrameCount - 1
        }
      });
    } else {
      dispatch({
        type: SIDE_PANEL_ACTIONS.DELETE_ANNOTATION,
        annotationIdx: annotationId
      });
    }
    onSubmit?.();
  };
  return <DeleteModalContent annotationId={annotationId} isVideoTask={isVideoTask} allAnnotationMap={allAnnotationMap} onSubmit={handleSubmit} onCancel={onCancel} timeDisplayMode={timeDisplayMode} maxFrames={maxFrames} frameRate={frameRate} associatedRelationships={associatedRelationships} />;
};